import { Container } from "@chakra-ui/react";

import HomeLayout from "../../components/layouts/homelayout";
import PageHeader from "../../components/sections/pageheader";

import careersFaqHeroImg from '../../components/ui/globalcareers/faq/careers_faq_banner.jpg';
import DynamicAccordion from "../../components/sections/accordion";

function CareersFaq() {

    const applicationProcessQuestions = [
        {
            value: "a",
            question: "How do I apply for a job at Columbia Sportswear Company?",
            answer: <>
                        <p>Start by visiting our <a href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/Columbia_Career_Site/" target="_blank" rel="noreferrer noopener">Careers Site</a> to explore current openings. You can search by keyword, location, or job category. Once you find a role that matches your interests and experience, click “Apply” to begin your application.</p>
                        <p>Note: Current employees and contractors should apply through our internal Careers Portal (Jobs Hub in Workday).</p>
                    </>
        },
        {
            value: "b",
            question: "How can I check the status of my application?",
            answer: <>
                        <p>Log into your <a href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/Columbia_Career_Site/userHome" target="_blank" rel="noreferrer noopener">Candidate Profile</a> on our Careers Portal and navigate to the “My Applications” section to view updates.</p>
                    </>
        },
        {
            value: "c",
            question: "Can I apply for more than one position?",
            answer: <>
                        <p>Yes! We encourage you to apply for any roles that align with your skills and career goals.</p>
                    </>
        },
        {
            value: "d",
            question: "Will I receive confirmation after applying?",
            answer: <>
                        <p>Absolutely. You will receive a confirmation email once your application is submitted. You can also track your status through your <a href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/Columbia_Career_Site/userHome" target="_blank" rel="noreferrer noopener">Candidate Profile</a>.</p>
                    </>
        },
        {
            value: "e",
            question: "How do I set up a job alert?",
            answer: <>
                        <p>Log into your <a href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/Columbia_Career_Site/userHome" target="_blank" rel="noreferrer noopener">Candidate Profile</a>, click on “Job Alerts” in the top right-hand corner and follow the instructions.</p>
                    </> 
        },
        {
            value: "f",
            question: "What if I need an accommodation or adjustment to successfully complete and submit my application?",
            answer: <>
                        <p>We are here to support you. Please email <a href="mailto:AskHR@columbia.com?subject=Applicant Assistance Requested" target="_blank" rel="noreferrer noopener">AskHR@columbia.com</a> with the subject line: Applicant Assistance Requested.</p>
                    </>
        },
        {
            value: "g",
            question: "What does it mean by “Source” when filling out an application?",
            answer: <>
                        <p>This refers to how you found the job. Common options include:</p>
                        <ul>
                            <li>Columbia Sportswear Company Careers Site</li>
                            <li>Employee Referral</li>
                            <li>LinkedIn, Indeed, Glassdoor</li>
                            <li>Social Media (e.g., Instagram)</li>
                            <li>Other</li>
                        </ul>
                        <p>If you were referred by a Columbia employee, select “Employee Referral” and enter your referrer’s name. If you are unsure, just choose the closest match.</p>
                        <p>If you are currently employed by Columbia Sportswear Company, you should apply through our internal Careers Portal (Jobs Hub in Workday).</p>
                    </>
        },
        {
            value: "h",
            question: "Will I be notified if the position is filled?",
            answer: <>
                        <p>Yes, all applicants will be informed once a position has been filled.</p>
                    </>
        }
    ];

    const interviewProcessQuestions = [
        {
            value: "i",
            question: "What should I expect during the interview process?",
            answer: <>
                        <p>The process varies by role but typically includes a phone or video interview with a recruiter, followed by video or in-person interviews with hiring managers or team members. If you need an accommodation/ adjustment to successfully complete and submit your application, please reach out to  <a href="mailto:AskHR@columbia.com?subject=Interview Assistance Requested" target="_blank" rel="noreferrer noopener">AskHR@columbia.com</a> with the Subject: Interview Assistance Requested.</p>
                    </>
        },
        {
            value: "j",
            question: "How long does the hiring process take?",
            answer: <>
                        <p>Timelines vary depending on the role and number of applicants. You can check your status anytime through your <a href="https://columbiasportswearcompany.wd5.myworkdayjobs.com/en-US/Columbia_Career_Site/userHome" target="_blank" rel="noreferrer noopener">Candidate Profile</a>.</p>
                    </>
        },
        {
            value: "k",
            question: "Will I be contacted even if I am not selected?",
            answer: <>
                        <p>We aim to keep all candidates informed. Communication may come via email or directly from our Talent Acquisition team.</p>
                    </>
        },
        {
            value: "l",
            question: "Do you offer virtual interviews?",
            answer: <>
                        <p>Yes, depending on the role. Your recruiter will provide details specific to your interview format.</p>
                    </>
        },
        {
            value: "m",
            question: "Is relocation assistance available?",
            answer: <>
                        <p>Relocation assistance may be available depending on the position. For some full‑time roles, Columbia Sportswear Company offers relocation support based on the level of the role and business needs. If relocation support is available for a specific role, it will be communicated during the recruiting process.</p>
                    </>
        }
    ];

    const jobRequirementsQuestions = [
        {
            value: "n",
            question: "Do I need to meet every qualification listed?",
            answer: <>
                        <p>Not necessarily. If you meet many of the qualifications, have transferable skills, and are excited about the role, we encourage you to apply.</p>
                    </>
        },
        {
            value: "o",
            question: "Do you offer internships?",
            answer: <>
                        <p>Yes! We offer 10-week summer internships at our corporate locations. Visit our <a href="https://www.columbiasportswearcompany.com/careers" target="_blank" rel="noopener noreferrer">Careers Site</a> for current opportunities. Please note relocation and housing are not provided.</p>
                    </>
        },
        {
            value: "p",
            question: "Are seasonal roles available?",
            answer: <>
                        <p>Yes, we offer seasonal positions in our retail stores and distribution centers. Availability varies, so check our <a href="https://www.columbiasportswearcompany.com/careers" target="_blank" rel="noopener noreferrer">Careers Site</a> regularly.</p>
                    </>
        },
        {
            value: "q",
            question: "Do you sponsor work visas in the United States?",
            answer: <>
                        <p>Sponsorship may be available for certain roles. Please refer to the job posting or speak with a recruiter for more information.</p>
                    </>
        },
    ];

    const workingAtCSCQuestions = [
        {
            value: "r",
            question: "What is the company culture like?",
            answer: <>
                        <p>Our culture is rooted in a passion for the outdoors, innovation, and inclusiveness. We foster a collaborative environment where employees are encouraged to be themselves and make a difference. Want a behind-the-scenes look? Check out our Instagram page <a href="https://www.instagram.com/lifeatcolumbiasportswear/?hl=en" target="_blank" rel="noopener noreferrer">@LifeatColumbiaSportswearCompany</a> for a glimpse into life at CSC. You can also check out our <a href="https://www.columbiasportswearcompany.com/our-company/global-culture">Global Culture</a> page for more information.</p>
                    </>
        },
        {
            value: "s",
            question: "Do you offer remote or hybrid work options?",
            answer: <>
                        <p>Work arrangements vary by role. Corporate roles currently follow a hybrid model, while Retail, Distribution, Customer Care and Photo Studio roles are fully onsite.</p>
                    </>
        },
        {
            value: "t",
            question: "What benefits do you offer full time employees?",
            answer: <>
                        <p>We offer competitive benefits including health insurance, retirement plans, personal time off, employee discounts, wellness programs, and more. Specific benefits offered will vary by location, role type, and/or hours worked.</p>
                    </>
        },
        {
            value: "u",
            question: "Are there opportunities for growth and development?",
            answer: <>
                        <p>Absolutely. We support career development through training, mentorship, and internal mobility programs.</p>
                    </>
        },
    ];

    const technicalSupportQuestions = [
        {
            value: "v",
            question: "Forgot your password?",
            answer: <>
                        <p>Click the “Forgot Password” link on the login page of our application portal to reset your password and follow the instructions.</p>
                    </>
        },
        {
            value: "w",
            question: "Having technical issues while applying?",
            answer: <>
                        <p>Most application issues can be resolved by trying the following steps:</p>
                        <ul>
                            <li>Refresh the page</li>
                            <li>Clear your browser cache</li>
                            <li>Try a different browser or device</li>
                        </ul>
                        <p>If you still need help, candidates can contact <a href="mailto:AskHR@columbia.com" target="_blank" rel="noopener noreferrer">AskHR@columbia.com</a> for basic account support such as updating your email address.</p>
                        <p>For platform-related issues that AskHR cannot resolve, we recommend trying again later or accessing the application using an alternate browser or device.</p>
                    </>
        },
        {
            value: "x",
            question: "Trouble uploading your resume?",
            answer: <>
                        <p>Ensure your file is in an accepted format (PDF or Word). If issues persist, try a different browser or device.</p>
                    </>
        }
    ];


    return (
        <HomeLayout>
            <title>Canadidate Frequently Asked Questions (FAQ) – Columbia Sportswear Company</title>
            <meta name="description" content="Frequently asked questions for job seekers." />
            <link rel="canonical" href="https://www.columbiasportswearcompany.com/careers/frequently-asked-questions" />

            <PageHeader 
                bkgImg={careersFaqHeroImg}
                heading="Candidate Frequently Asked Questions (FAQ)"
            />

            <Container maxW='7xl' my={14} className='flow' style={{ '--flow-space': 'var(--space-xl)' }}>
                <section className='flow mw-prose'>
                    <h2 style={{lineHeight:1.1, fontSize: 'var(--step-4)'}}>Welcome! We are excited you are considering a career with Columbia Sportswear Company.</h2>
                    <p className="lede">Whether you are just starting your application or preparing for an interview, this guide is here to support you every step of the way.</p>
                </section>

                <section>
                    <h3>Application Process</h3>
                    <DynamicAccordion data={applicationProcessQuestions} />
                </section>

                <section>
                    <h3>Interview Process</h3>
                    <DynamicAccordion data={interviewProcessQuestions} />
                </section>

                <section>
                    <h3>Job Requirements & Eligibility</h3>
                    <DynamicAccordion data={jobRequirementsQuestions} />
                </section>

                <section>
                    <h3>Working at Columbia Sportswear Company</h3>
                    <DynamicAccordion data={workingAtCSCQuestions} />
                </section>

                <section>
                    <h3>Technical Support</h3>
                    <DynamicAccordion data={technicalSupportQuestions} />
                </section>

            </Container>
        </HomeLayout>
    );
}

export default CareersFaq;